import { IRequest } from '../types/IRequest';
import { IServer } from '../types/IServer';

export type RequestHeaders = {
  [name: string]: string;
}

export class Request<TParams, TResult> implements IRequest<TParams, TResult> {

  public method: string;
  public params: TParams;

  constructor(method: string, params: TParams, public headers?: RequestHeaders) {
    this.method = method;
    this.params = params;
  }

  // This is not used anywhere. Its only purpose is to use TResult so that Result doesn't lose type safety.
  // Later versions of TypeScript might not need this.
  // Note (abrandon 2020-01-24): I think this method is actually occluding type-safety. The compiler still isn't great,
  // but if we try to remove this method, we get legitimate type errors that were masked by this.
  public send(server: IServer): ng.IPromise<TResult> {
    return server.sendRequest<TParams, TResult>(this);
  }

}
